export default "__VITE_ASSET__SzW$Pkxq__"